<svg
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  [attr.viewBox]="viewBoxString"
  id="swingFlexCorpus2d"
  preserveAspectRatio="xMinYMin"
  class="cabinet-section-2d swing-2d"
  (click)="selectSwingSubArea(null); $event.preventDefault()"
  (mousemove)="mouseMove($event)"
  (mouseup)="mouseUp($event)"
  (mousedown)="backgroundMouseDown($event)"
  (touchmove)="mouseMove($event)"
  (touchend)="mouseUp($event)"
  (touchstart)="backgroundMouseDown($event)"
>
  <g class="ruler-view" *ngIf="showRulers">
    <g *ngFor="let ruler of rulers">
      <g
        class="ruler vertical-ruler"
        *ngIf="ruler.isVertical"
        attr.transform="translate( {{ ruler.svgStart.X }} {{
          ruler.svgStart.Y
        }} )"
      >
        <line
          class="ruler-line ruler-serif"
          style="stroke: black; stroke-width: 3px"
          [attr.x1]="-ruler.serifSize"
          [attr.x2]="ruler.serifSize"
          y1="0"
          y2="0"
        />
        <line
          class="ruler-line ruler-serif"
          style="stroke: black; stroke-width: 3px"
          [attr.x1]="-ruler.serifSize"
          [attr.x2]="ruler.serifSize"
          [attr.y1]="-ruler.length"
          [attr.y2]="-ruler.length"
        />
        <line
          class="ruler-line ruler-main-line"
          style="stroke: black; stroke-width: 3px"
          y1="0"
          [attr.y2]="-ruler.length"
          x1="0"
          x2="0"
        />
        <text
          class="ruler-text"
          style="font-size: 50px"
          x="-10px"
          [attr.y]="-ruler.length / 2"
          attr.transform="rotate( -90 0 {{ -ruler.length / 2 }} )"
          text-anchor="middle"
        >
          {{ ruler.length.toFixed(0) }}
        </text>
      </g>

      <g
        class="ruler horizontal-ruler"
        *ngIf="!ruler.isVertical"
        attr.transform="translate( {{ ruler.svgStart.X }} {{
          ruler.svgStart.Y
        }} )"
      >
        <line
          class="ruler-line ruler-serif"
          style="stroke: black; stroke-width: 3px"
          x1="0"
          x2="0"
          [attr.y1]="-ruler.serifSize"
          [attr.y2]="ruler.serifSize"
        />
        <line
          class="ruler-line ruler-serif"
          style="stroke: black; stroke-width: 3px"
          [attr.x1]="ruler.length"
          [attr.x2]="ruler.length"
          [attr.y1]="-ruler.serifSize"
          [attr.y2]="ruler.serifSize"
        />
        <line
          class="ruler-line ruler-main-line"
          style="stroke: black; stroke-width: 3px"
          x1="0"
          [attr.x2]="ruler.length"
          y1="0"
          y2="0"
        />
        <text
          class="ruler-text"
          style="font-size: 50px"
          y="-10px"
          [attr.x]="ruler.length / 2"
          text-anchor="middle"
        >
          {{ ruler.length.toFixed(0) }}
        </text>
      </g>
    </g>
  </g>

  <g class="front-view">
    <rect
      class="cabinet-section-border"
      x="0"
      y="0"
      width="0"
      height="0"
      style="fill: none; stroke: black; stroke-width: 3px"
      [attr.width]="cabinetSection.interior.cube.Width"
      [attr.height]="cabinetSection.interior.cube.Height"
      [attr.x]="cabinetSection.interior.cube.X"
      [attr.y]="
        cabinetSection.Height -
        cabinetSection.interior.cube.Height -
        cabinetSection.interior.cube.Y
      "
    ></rect>

    <g *ngFor="let item of backingItems">
      <g
        *ngIf="isItemDisplayed(item)"
        [app-interior-item]="item"
        class="item"
      ></g>
    </g>

    <g *ngFor="let item of interiorItems">
      <g
        class="placed-item"
        [app-interior-item]="item"
        *ngIf="isItemDisplayed(item)"
      >
        <rect
          width="0"
          height="0"
          class="item-mouse-area"
          style="fill: rgba(0, 0, 0, 0)"
          [attr.height]="item.mouseClickOffset.Height"
          [attr.width]="item.mouseClickOffset.Width"
          [attr.x]="item.mouseClickOffset.X"
          [attr.y]="item.mouseClickOffset.Y"
          (mouseup)="mouseUp($event)"
        ></rect>
      </g>
    </g>

    <g *ngFor="let item of swingItems">
      <g
        *ngIf="isItemDisplayed(item)"
        [attr.description]="item.Description"
        [app-interior-item]="item"
        class="item"
      ></g>
    </g>

    <g *ngFor="let item of swingItems">
      <g
        *ngIf="isItemDisplayed(item) &amp;&amp; isItemSelected(item)"
        [attr.description]="item.Description"
        [app-interior-item]="item"
        class="item"
        [class]="{ 'movable-item': isItemMoveable(item) }"
        (mouseDown)="itemMouseDown($event, item)"
        [showItem]="false"
      >
        <rect
          class="selected-item-outline"
          x="-5"
          y="-5"
          width="0"
          height="0"
          [attr.height]="item.Height + 10"
          [attr.width]="item.visualWidth + 10"
        ></rect>
      </g>
    </g>

    <g class="swing-door-hinges" *ngIf="showHinges">
      <g *ngFor="let hinge of hinges">
        <rect
          width="0"
          height="0"
          [attr.style]="hinge.style"
          [attr.height]="hinge.height"
          [attr.width]="hinge.width"
          [attr.x]="hinge.x"
          [attr.y]="hinge.y"
          [attr.transform]="getHingeTransformString(hinge)"
        ></rect>

        <text
          class="hinge-text"
          style="font-size: 40px; pointer-events: none"
          [attr.x]="hinge.x + hinge.width / 2"
          [attr.y]="hinge.y + hinge.height / 2"
          [attr.transform]="getHingeTransformString(hinge)"
          dominant-baseline="central"
          text-anchor="middle"
        >
          {{ hinge.text }}
        </text>
      </g>
    </g>

    <g class="swing-door-grips">
      <g *ngFor="let item of gripItems" style="pointer-events: none">
        <g [app-interior-item]="item" *ngIf="isItemDisplayed(item)"></g>
      </g>
    </g>

    <g class="corpus" *ngIf="showCorpus">
      <g class="corpus-items">
        <g
          *ngFor="let item of corpusItems"
          class="corpus-item"
          [app-interior-item]="item"
        >
          <g class="item-ruler" *ngIf="showRulers">
            <rect
              class="item-ruler-background"
              width="0"
              style="fill: rgba(255, 255, 255, 0.5)"
              height="0"
              [attr.width]="80"
              [attr.height]="itemRulerBackgroundHeight"
              [attr.x]="(item.Width - 80) / 2"
              [attr.y]="(item.Height - itemRulerBackgroundHeight) / 2"
            ></rect>

            <text
              class="item-ruler-text"
              style="font-size: 40px; pointer-events: none"
              [attr.x]="item.Width / 2"
              [attr.y]="item.Height / 2 + 13"
              text-anchor="middle"
            >
              {{ item.PositionNumber }}
            </text>
          </g>
        </g>
      </g>
      <g class="corpus-joints">
        <g class="corpus-joint" *ngFor="let joint of corpusJoints">
          <line
            x1="0"
            x2="0"
            y1="0"
            y2="0"
            [attr.y2]="-joint.height"
            attr.transform="translate( {{ joint.X }} {{
              cabinetSection.Height - joint.Y
            }} )"
            style="stroke: black; stroke-width: 10px"
          ></line>
        </g>
      </g>
    </g>

    <g
      class="snap-info"
      *ngIf="dragInfo &amp;&amp; (dragInfo.type === 'ItemDragInfo') "
    >
      <g
        *ngFor="let item of dragInfo.snapInfo.snappingItems"
        [attr.transform]="getDragOverlayTransformString(item)"
      >
        <g
          attr.transform="translate( {{ dragInfo.snapInfo.dropOffset.X }} {{
            -dragInfo.snapInfo.dropOffset.Y
          }} )"
        >
          <rect
            class="item-snap-pos"
            width="0"
            height="0"
            [attr.width]="(dragInfo.snapInfo.newSize &amp;&amp; dragInfo.snapInfo.newSize.X) || item.Width"
            [attr.height]="item.Height"
          ></rect>
        </g>

        <g
          *ngFor="let offset of dragInfo.snapInfo.suggestedItemOffsets"
          attr.transform="translate( {{ offset.X }} {{ -offset.Y }} )"
        >
          <rect
            class="drag-suggested-position"
            width="0"
            height="0"
            [attr.width]="item.Width"
            [attr.height]="item.Height"
          ></rect>
        </g>
      </g>

      <g
        class="drag-support-ruler"
        *ngFor="let ruler of dragInfo.snapInfo.rulers"
      >
        <g
          class="ruler vertical-ruler"
          *ngIf="ruler.isVertical"
          attr.transform="translate( {{ ruler.svgStart.X }} {{
            ruler.svgStart.Y
          }} )"
        >
          <line
            class="ruler-line ruler-serif"
            style="stroke: black; stroke-width: 3px"
            [attr.class]="{ 'custom-size': ruler.isCustom }"
            [attr.x1]="-ruler.serifSize"
            [attr.x2]="ruler.serifSize"
            y1="0"
            y2="0"
          />
          <line
            class="ruler-line ruler-serif"
            style="stroke: black; stroke-width: 3px"
            [attr.class]="{ 'custom-size': ruler.isCustom }"
            [attr.x1]="-ruler.serifSize"
            [attr.x2]="ruler.serifSize"
            [attr.y1]="-ruler.length"
            [attr.y2]="-ruler.length"
          />
          <line
            class="ruler-line ruler-main-line"
            style="stroke: black; stroke-width: 3px"
            [attr.class]="{ 'custom-size': ruler.isCustom }"
            y1="0"
            [attr.y2]="-ruler.length"
            x1="0"
            x2="0"
          />
          <text
            class="ruler-text"
            [attr.class]="{ 'custom-size': ruler.isCustom }"
            style="font-size: 50px"
            x="-10px"
            [attr.y]="-ruler.length / 2"
            attr.transform="rotate( -90 0  {{ -ruler.length / 2 }} )"
            text-anchor="middle"
          >
            {{ ruler.length.toFixed(0) }}
          </text>
        </g>

        <g
          class="ruler horizontal-ruler"
          *ngIf="!ruler.isVertical"
          attr.transform="translate( {{ ruler.svgStart.X }} {{
            ruler.svgStart.Y
          }} )"
        >
          <line
            class="ruler-line ruler-serif"
            style="stroke: black; stroke-width: 3px"
            [attr.class]="{ 'custom-size': ruler.isCustom }"
            x1="0"
            x2="0"
            [attr.y1]="-ruler.serifSize"
            [attr.y2]="ruler.serifSize"
          />
          <line
            class="ruler-line ruler-serif"
            style="stroke: black; stroke-width: 3px"
            [attr.class]="{ 'custom-size': ruler.isCustom }"
            [attr.x1]="ruler.length"
            [attr.x2]="ruler.length"
            [attr.y1]="-ruler.serifSize"
            [attr.y2]="ruler.serifSize"
          />
          <line
            class="ruler-line ruler-main-line"
            style="stroke: black; stroke-width: 3px"
            [attr.class]="{ 'custom-size': ruler.isCustom }"
            x1="0"
            [attr.x2]="ruler.length"
            y1="0"
            y2="0"
          />
          <text
            class="ruler-text"
            [attr.class]="{ 'custom-size': ruler.isCustom }"
            style="font-size: 50px"
            y="-10px"
            [attr.x]="ruler.length / 2"
            text-anchor="middle"
          >
            {{ ruler.length.toFixed(0) }}
          </text>
        </g>
      </g>
    </g>

    <g class="item-collision-areas">
      <g
        *ngFor="let item of swingItems"
        [attr.itemindex]="item.ConfigurationItemIndex"
        class="collision-warning"
      >
        <rect
          *ngFor="let collisionArea of item.collisions"
          [attr.space]="collisionArea.space"
          [attr.severity]="collisionArea.severity"
          width="0"
          height="0"
          [attr.width]="collisionArea.Width"
          [attr.height]="collisionArea.Height"
          [attr.x]="collisionArea.X"
          [attr.y]="
            cabinetSection.Height - collisionArea.Height - collisionArea.Y
          "
          style="
            stroke: none;
            stroke-width: 20px;
            fill: yellow;
            opacity: 0.3;
            pointer-events: none;
          "
        />
      </g>
    </g>

    <g class="item-rulers" *ngIf="showRulers">
      <g *ngFor="let item of rulerItems">
        <g
          class="item-ruler-overlay"
          [app-interior-item]="item"
          [showItem]="false"
          *ngIf="shouldDisplayRulerFor(item)"
          style="pointer-events: none"
        >
          <rect
            class="item-ruler-background"
            width="0"
            style="fill: rgba(255, 255, 255, 0.5)"
            height="0"
            [attr.width]="getItemRulerBackgroundWidth(item)"
            [attr.height]="itemRulerBackgroundHeight"
            [attr.x]="(item.Width - getItemRulerBackgroundWidth(item)) / 2"
            [attr.y]="(item.Height - itemRulerBackgroundHeight) / 2"
          ></rect>

          <text
            class="item-ruler-text"
            style="font-size: 40px; pointer-events: none"
            [attr.x]="item.Width / 2"
            [attr.y]="item.Height / 2 + 13"
            text-anchor="middle"
          >
            {{ getItemRulerString(item) }}
          </text>
        </g>
      </g>
    </g>

    <g class="swing-area-overlays">
      <rect
        *ngFor="let swingSubArea of swingSubAreas"
        class="select-marker swing-select-marker"
        [class]="{ selected: isSwingSubAreaSelected(swingSubArea) }"
        style="opacity: 0"
        (click)="selectSwingSubArea(swingSubArea); $event.stopPropagation()"
        (touchend)="selectSwingSubArea(swingSubArea); $event.stopPropagation()"
        x="0"
        y="0"
        width="0"
        height="0"
        [attr.x]="swingSubArea.insideRect.X"
        [attr.y]="
          getSubAreaOffsetY(swingSubArea) -
          swingSubArea.insideRect.Y -
          swingSubArea.insideRect.Height
        "
        [attr.width]="swingSubArea.insideRect.Width"
        [attr.height]="swingSubArea.insideRect.Height"
      ></rect>
    </g>

    <g *ngFor="let item of swingItems">
      <g
        *ngIf="isItemDisplayed(item) &amp;&amp; isItemMoveable(item)"
        [app-interior-item]="item"
        [showItem]="false"
        class="item"
        [class]="{ 'movable-item': isItemMoveable(item) }"
        (mousedown)="itemMouseDown($event, item)"
        (touchstart)="itemMouseDown($event, item)"
      >
        <rect
          x="-20"
          y="0"
          width="0"
          height="0"
          style="fill: rgba(0, 0, 0, 0)"
          [attr.y]="getSelectBoxOffsetY(item)"
          [attr.height]="getSelectBoxHeight(item)"
          [attr.width]="item.visualWidth + 40"
        ></rect>
      </g>
    </g>
  </g>

  <g class="ruler-view" *ngIf="showBackingRulers">
    <g *ngFor="let ruler of backingRulers">
      <g
        class="ruler horizontal-ruler"
        attr.transform="translate( {{ ruler.svgStart.X }} {{
          ruler.svgStart.Y
        }} )"
      >
        <line
          class="ruler-line ruler-serif"
          style="stroke: black; stroke-width: 3px"
          x1="0"
          x2="0"
          [attr.y1]="-ruler.serifSize"
          [attr.y2]="ruler.serifSize"
        />
        <line
          class="ruler-line ruler-serif"
          style="stroke: black; stroke-width: 3px"
          [attr.x1]="ruler.length"
          [attr.x2]="ruler.length"
          [attr.y1]="-ruler.serifSize"
          [attr.y2]="ruler.serifSize"
        />
        <line
          class="ruler-line ruler-main-line"
          style="stroke: black; stroke-width: 3px"
          x1="0"
          [attr.x2]="ruler.length"
          y1="0"
          y2="0"
        />
        <text
          class="ruler-text"
          style="font-size: 50px"
          y="-10px"
          [attr.x]="ruler.length / 2"
          text-anchor="middle"
        >
          {{ ruler.length.toFixed(0) }}
        </text>
      </g>
    </g>
  </g>

  <g
    class="swing-door-view"
    attr.transform="translate(0, {{ cabinetSection.Height + 10 }})"
    *ngIf="showTopdown"
  >
    <g *ngFor="let door of doors">
      <line
        x1="0"
        y1="0"
        x2="0"
        y2="0"
        [attr.x1]="door.pos1.X"
        [attr.y1]="door.pos1.Y"
        [attr.x2]="door.pos2.X"
        [attr.y2]="door.pos2.Y"
        stroke="black"
        style="stroke-width: 19"
      ></line>
    </g>
  </g>
</svg>
